
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_swimc_16ofg_189",
  "anchor-list": "awsui_anchor-list_swimc_16ofg_221",
  "anchor-item": "awsui_anchor-item_swimc_16ofg_244",
  "anchor-item--active": "awsui_anchor-item--active_swimc_16ofg_264",
  "anchor-link": "awsui_anchor-link_swimc_16ofg_281",
  "anchor-link--active": "awsui_anchor-link--active_swimc_16ofg_323",
  "anchor-link-text": "awsui_anchor-link-text_swimc_16ofg_330",
  "anchor-link-info": "awsui_anchor-link-info_swimc_16ofg_334"
};
  